import { GROUPS_PHASES_REQUEST, GROUPS_PHASES_LIST, GROUPS_PHASES_EDIT,
		GROUPS_PHASES_CLEAR, GROUPS_PHASES_FAIL} from "../store/config";

const groupsInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	edit: {},
	permissions:[],
	error: undefined,
	timestamp: undefined
}

const groupsPhases = (state = groupsInit, action) => {
	switch (action.type) {
		case GROUPS_PHASES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case GROUPS_PHASES_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case GROUPS_PHASES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case GROUPS_PHASES_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case GROUPS_PHASES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default groupsPhases;


// WEBPACK FOOTER //
// ./src/reducers/groups_phases.js